import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroPolizaContable;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}


/**
* Componente para editar un Entity
*/
export class FiltroPolizaContableComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Date = getField(kea.DateTime);
        const Origen = getField(selectores.OrigenPolizaContable);
        const EmpresaLogistica = getField(selectores.EmpresaLogistica);

        return (
            <div>
                {kea.autogrid(3, [
                    <Date field="FechaCreacionInicio" label="Fecha de creación (inicio)" time />,
                    <Date field="FechaCreacionFinal" label="Fecha de creación (final)" time />,
                    <Origen field="Origen" label="Tipo de origen" />,
                    <EmpresaLogistica field="EsLogistica" label="Empresa"  />,
                ])}
            </div>);
    }
}   


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/polizas/list/filtro.tsx